import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { PageHero, FeatureGrid, CTABand } from "@/components/public/PageHero";
import { HeartPulse, Brain, Users, Leaf, Sun, Activity } from "lucide-react";

const FEATURES = [
  { icon: HeartPulse, title: "Body", body: "Gentle movement, safety, and daily wellbeing so your loved one stays strong and comfortable." },
  { icon: Brain, title: "Mind", body: "Engagement and routine that support memory, mood, and a sense of purpose." },
  { icon: Users, title: "Connection", body: "Community and companionship that keep loneliness away after a transition." },
  { icon: Leaf, title: "Whole-person care", body: "We look beyond the move to how your loved one is truly doing, week after week." },
  { icon: Sun, title: "A brighter day-to-day", body: "Small, steady supports that add up to a fuller, happier life." },
  { icon: Activity, title: "Ongoing check-ins", body: "We stay close, so families have peace of mind long after the boxes are unpacked." },
];

export default function TrilogyWellness() {
  const { content } = useOutletContext();
  useEffect(() => { document.title = "Trilogy Senior Wellness · MovingMyMama"; }, []);
  const t = content?.trilogy || {};
  const img = t.image_url || content?.hero?.image_url;
  return (
    <div data-testid="trilogy-page">
      <PageHero
        eyebrow="Trilogy Senior Wellness"
        title="Because how your loved one is doing matters most."
        subtitle={t.body || "Trilogy Senior Wellness supports body, mind, and connection — helping seniors stay healthy, active, and engaged long after a transition."}
        image={img}
      />
      <FeatureGrid items={FEATURES} />
      <CTABand
        title="Ask us about Trilogy Senior Wellness."
        subtitle="We'll help you understand how ongoing wellness support can fit your family's plan."
      />
    </div>
  );
}
